import { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { UserProvider } from "./context/UserContext";

// Page Imports
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Logout from "./pages/Logout";

import Profile from "./pages/Profile";

import Cart from "./pages/Cart";
import Orders from "./pages/Orders";
import ManageOrder from "./pages/ManageOrder";

import Products from "./pages/Products";
import CreateProduct from "./pages/CreateProduct";

import "notyf/notyf.min.css";

import AppNavbar from "./components/AppNavbar";
import Footer from "./components/Footer";

function App() {
  const [user, setUser] = useState(null);

  const fetchUserData = async (token) => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/users/details`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("User data fetched:", data);
        localStorage.setItem("token", JSON.stringify(data));
        setUser(data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchUserData(token);
    }
  }, []);

  return (
    <UserProvider value={{ user, setUser, fetchUserData }}>
      <Router>
        <div className="app-main-content">
          <AppNavbar />

          <Routes>
            <Route path="/" element={<Home />} />
            {/* User Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/logout" element={<Logout />} />
            {/* Profile Route */}
            <Route path="/profile" element={<Profile />} />
            {/* Product Routes */}
            <Route path="/products" element={<Products />} />
            <Route path="/add-product" element={<CreateProduct />} />

            {/* User Orders Route */}
            <Route path="/orders" element={<Orders />} />
            <Route path="/orders/:orderId" element={<ManageOrder />} />
            {/* Cart Route */}
            <Route path="/cart" element={<Cart />} />
          </Routes>
        </div>

        <Footer />
      </Router>
    </UserProvider>
  );
}

export default App;
